<template>
  <figure class="relative h-full w-full">
    <video
      ref="videoRef"
      autoplay
      loop
      muted
      playsinline
      :class="[
        'object-cover',
        'h-full',
        'w-full',
        props.videoClass && props.videoClass !== '' ? props.videoClass : ''
      ]"
    >
      <source :src="props.video" type="video/mp4" />
    </video>
    <button
      :aria-label="isPlaying ? ariaLabels.pause : ariaLabels.play"
      class="flex gap-x-2 items-center min-h-10 rounded bg-white text-black px-2 hover:bg-light-green absolute bottom-4 right-4"
      @click="toggelVideo"
    >
      <span aria-hidden="true">
        <svg
          v-if="isPlaying"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 16C9.45 16 9 15.55 9 15V9C9 8.45 9.45 8 10 8C10.55 8 11 8.45 11 9V15C11 15.55 10.55 16 10 16ZM14 16C13.45 16 13 15.55 13 15V9C13 8.45 13.45 8 14 8C14.55 8 15 8.45 15 9V15C15 15.55 14.55 16 14 16Z"
            fill="#111111"
          />
        </svg>
        <svg
          v-else
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM9.5 14.67V9.33C9.5 8.54 10.38 8.06 11.04 8.49L15.19 11.16C15.8 11.55 15.8 12.45 15.19 12.84L11.04 15.51C10.38 15.94 9.5 15.46 9.5 14.67Z"
            fill="#111111"
          />
        </svg>
      </span>
      <span class="label-sm">
        {{ isPlaying ? buttonTexts.pause : buttonTexts.play }}
      </span>
    </button>
  </figure>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

const props = defineProps<{ video: string; videoClass?: string; lang: string }>()

const videoRef = ref<HTMLVideoElement | null>(null)
const isPlaying = ref(true)

const toggelVideo = () => {
  if (!videoRef.value) return

  if (isPlaying.value) {
    videoRef.value.pause()
  } else {
    videoRef.value.play()
  }

  isPlaying.value = !isPlaying.value
}

// Define the texts based on language
const buttonTexts = computed(() => {
  return props.lang === 'en'
    ? { play: 'Play video', pause: 'Pause video' }
    : { play: 'Spela klipp', pause: 'Pausa klipp' }
})

const ariaLabels = computed(() => {
  return props.lang === 'en'
    ? { play: 'Play video', pause: 'Pause video' }
    : { play: 'Spela klipp', pause: 'Pausa klipp' }
})
</script>

<style></style>
